import { render, staticRenderFns } from "./tabTermos.vue?vue&type=template&id=5079e96a"
import script from "./tabTermos.vue?vue&type=script&lang=js"
export * from "./tabTermos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports